import request from "../utils/request.js"
// 获取服务列表
export function getServiceList(params) {
    return request({
        url: "/service/list",
        method: "post",
        data: params,
    })
}
// 获取服务列表
export function getServiceDemandList(params, value) {
    let url
    if (value) {
        url = "/service/demandList?value=" + value
    } else {
        url = "/service/demandList"
    }
    return request({
        url: url,
        method: "post",
        data: params,
    })
}
// 获取服务列表
export function saveService(params) {
    return request({
        url: "/service/saveService",
        method: "post",
        data: params,
    })
}
// 获取服务类型列表
export function getServiceType() {
    return request({
        url: "/service/getServiceType",
        method: "get"
    })
}
// 获取单位类型列表
export function getPriceCompanyType() {
    return request({
        url: "/service/getPriceCompanyType",
        method: "get"
    })
}
// 获取服务详情
export function getServiceDetail(params) {
    return request({
        url: "/service/detail/"+params,
        method: "get"
    })
}
// 删除服务
export function deleteService(id) {
    return request({
        url: "/service/removeService/"+id,
        method: "post"
    })
}